module.exports = __webpack_public_path__ + "static/media/ProximaNova-Regular.1fc524a2.ttf";